import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ErrorAlert } from '@/components/ErrorAlert';
import { PageHeader } from '@/components/PageHeader';
import { formatDateTime, ticketLabel } from '@/lib/format';
import { orpc } from '@/lib/orpc';
import { useMe } from '@/lib/session';

export const Route = createFileRoute('/_app/approvals')({ component: ApprovalsPage });

function ApprovalsPage() {
  const { t } = useTranslation();
  const me = useMe();
  const pending = useQuery({ ...orpc.tickets.list.queryOptions({ input: { assigneeId: me.id, statuses: ['proposed'], limit: 100 } }), refetchInterval: 30_000 });
  return (
    <div>
      <PageHeader title={t('approvals.title')} lead={t('approvals.lead')} />
      {pending.isError && <ErrorAlert error={pending.error} />}
      {pending.data && !pending.data.items.length && <p className="text-base-content/60">{t('approvals.empty')}</p>}
      <ul className="space-y-2">
        {pending.data?.items.map((tk) => (
          <li key={tk.id} className="bg-base-100 rounded-box flex flex-wrap items-center gap-3 p-4 shadow-sm">
            <span className="text-base-content/60 font-mono text-xs">{ticketLabel(tk.number)}</span>
            <Link to="/tickets/$ref" params={{ ref: ticketLabel(tk.number) }} className="link link-hover font-medium">
              {tk.title}
            </Link>
            <span className="text-base-content/70 text-sm">{tk.requesterName}</span>
            <span className="text-base-content/50 ml-auto text-xs">{formatDateTime(tk.updatedAt)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
